module.exports = __webpack_public_path__ + "img/ek-tanerolmez-ayak-izi-eba@2x.e0505cf3.png";